(() => {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[name="language_code"]');
      this.button = this.querySelector('[data-localization-toggle]');
      this.menu = this.querySelector('.language-selector__menu');
      this.form = this.querySelector('form');
      if (!this.input || !this.button || !this.menu || !this.form) return;
      this.button.addEventListener('click', () => this.toggle());
      this.querySelectorAll('[data-value]').forEach(item => item.addEventListener('click', event => this.select(event)));
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') { this.close(); this.button.focus(); }
      });
      document.addEventListener('click', event => { if (!this.contains(event.target)) this.close(); });
    }
    toggle() {
      const isOpen = !this.menu.hasAttribute('hidden');
      if (isOpen) this.close(); else this.open();
    }
    open() { this.menu.removeAttribute('hidden'); this.button.setAttribute('aria-expanded', 'true'); }
    close() { this.menu.setAttribute('hidden', ''); this.button.setAttribute('aria-expanded', 'false'); }
    select(event) {
      event.preventDefault();
      this.input.value = event.currentTarget.dataset.value;
      this.form.submit();
    }
  }
  if (!customElements.get('localization-form')) customElements.define('localization-form', LocalizationForm);

  const header = document.querySelector('[data-site-header]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const body = document.querySelector('[data-drawer-body]');
  const foot = document.querySelector('[data-drawer-foot]');
  const count = document.querySelector('[data-cart-count]');
  const strings = window.themeStrings || { cart: {} };
  const root = window.Shopify?.routes?.root || '/';
  const route = path => `${root}${path.replace(/^\//, '')}`;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-FI', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' }).format(cents / 100);
  const setHeader = () => { if (header && document.body.classList.contains('template-index')) header.classList.toggle('solid', window.scrollY > 20); };
  const empty = () => `<div class="drawer-empty"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1 12H6L5 8Z"/><path d="M9 9V6a3 3 0 0 1 6 0v3"/></svg><h3>${strings.cart.emptyTitle || ''}</h3><p>${strings.cart.emptyCopy || ''}</p><button class="button" type="button" data-cart-close>${strings.cart.continueShopping || ''}</button></div>`;
  const render = cart => {
    if (!body) return;
    if (count) count.textContent = cart.item_count;
    if (!cart.items.length) { body.innerHTML = empty(); if (foot) foot.hidden = true; return; }
    body.innerHTML = `<div class="drawer-items">${cart.items.map(item => `<article class="drawer-item"><img src="${item.image || ''}" alt="${item.product_title}"><div><h3>${item.product_title}</h3><p>${item.quantity} × ${money(item.final_price)}</p></div><b>${money(item.final_line_price)}</b></article>`).join('')}</div>`;
    if (foot) { foot.hidden = false; const total = foot.querySelector('[data-cart-total]'); if (total) total.textContent = money(cart.total_price); }
  };
  const refresh = () => fetch(route('cart.js')).then(response => response.json()).then(render);
  const open = () => { refresh().finally(() => drawer?.classList.add('open')); };
  const close = () => drawer?.classList.remove('open');
  setHeader();
  window.addEventListener('scroll', setHeader, { passive: true });
  document.addEventListener('click', event => {
    if (event.target.closest('[data-cart-open]')) { event.preventDefault(); open(); }
    if (event.target.closest('[data-cart-close]')) { event.preventDefault(); close(); }
    if (event.target.closest('[data-menu]')) header?.classList.toggle('menu-open');
    const minus = event.target.closest('[data-qty-minus]');
    const plus = event.target.closest('[data-qty-plus]');
    if (minus || plus) { const input = event.target.closest('.qty-box')?.querySelector('input'); if (input) input.value = Math.max(1, Number(input.value || 1) + (plus ? 1 : -1)); }
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;
    fetch(route('cart/add.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(response => { if (!response.ok) throw new Error('Cart add failed'); return response.json(); })
      .then(() => refresh()).then(() => drawer?.classList.add('open'))
      .catch(() => form.submit()).finally(() => { if (button) button.disabled = false; });
  });
  refresh().catch(() => {});
})();
